import React, { useContext, useState, useRef, useEffect } from "react";
import Pagereview from "../../components/pageReview/Pagereview";
import Xlogo from "../../assets/icons/XIcon.svg";
import facebookLogo from "../../assets/icons/facebookIcon.svg";
import linkedinLogo from "../../assets/icons/LinkedinIcon.svg";
import youtubeLogo from "../../assets/icons/youtubeIcon.svg";
import instagramLogo from "../../assets/icons/InstagramIcon.svg";
import { MdEmail, MdFax, MdOutlineSupportAgent, MdPhone } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FormContext } from "../CMSRenderer/CMSRenderer";
import { CountriesList } from "../../components/pageReview/countrieslist";

const ContactDHA = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    comment: "",
    queryAbout: ""
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(CountriesList[0]);
  const [selectedQuery, setSelectedQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const selectRef = useRef(null);

  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setDropdownOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^\d+$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must contain only numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getFormValues = async () => {
    const querySelect = document.getElementById('querySelect');
    let selectedQueryValue = selectedQuery;
    
    if (querySelect) {
      try {
        const selectedValue = await querySelect.getSelectedText();
        selectedQueryValue = selectedValue;
        setSelectedQuery(selectedValue);
      } catch (error) {
        console.error('Error getting selected value:', error);
      }
    }

    const formValues = {
      fullName: formData.name,
      email: formData.email,
      mobileNumber: `${selectedCountry.code}${formData.phoneNumber}`,
      inqueryType: selectedQueryValue,
      message: formData.comment || ""
    };
    return formValues;
  };

  const resetForm = () => {
    setFormData({
      name: "",
      email: "",
      phoneNumber: "",
      comment: "",
      queryAbout: ""
    });
    setSelectedQuery("");
    setSelectedCountry(CountriesList[0]);
    setErrors({});
    setFormKey(prev => prev + 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      const formValues = await getFormValues();
      console.log("formValues:", formValues);
      
      const result = await fetch('/api/content/contactUsInquery', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formValues)
      });
      const json = await result.json();
      console.log("json:", json);
      
      if (result.ok) {
        setShowSuccessModal(true);
        resetForm();
      }
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  useEffect(() => {
    const handleQueryChange = () => {
      if (errors.queryAbout) {
        setErrors(prev => ({ ...prev, queryAbout: "" }));
      }
    };

    const selectElement = document.getElementById('querySelect');
    if (selectElement) {
      selectElement.addEventListener('change', handleQueryChange);
      return () => selectElement.removeEventListener('change', handleQueryChange);
    }
  }, [errors.queryAbout]);

  return (
    <>
      <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs={`[{"text":"${currentLang === "en" ? config.home : config.home_ar ? config.home_ar : config.home
          }","icon":"home","url":"/"},{"text":"${currentLang === "en" ? config.contact_dha : config.contact_dha_ar ? config.contact_dha_ar : config.contact_dha
          }","icon":"menu_book","url":"/contactus"}]`}
      ></dda-breadcrumb>

      {showSuccessModal && (
        <div className="fixed top-0 right-0 w-full h-full bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white w-full max-w-md rounded-xl p-6 m-4 shadow-lg text-center">
            <div className="flex justify-end">
              <button onClick={handleCloseModal}>
                <IoIosCloseCircleOutline className="text-2xl" />
              </button>
            </div>
            <img
              src="/attachments/medialib/54008598-1ba2-4e45-b082-5394429e666f-1759140690289-684313320-ThankYou.svg"
              alt="Thank you illustration"
              className="w-32 mx-auto my-4"
            />
            <h4 className="mb-4">
              {currentLang === "ar" ? "شكرًا لك!" : "Thank You!"} <br />
              {currentLang === "ar"
                ? "لقد تم إرسال رسالتك بنجاح"
                : "Your message has been sent."}
            </h4>
          </div>
        </div>
      )}

      <div className="space-y-[30px] md:space-y-[70px]">
        <div>
          <h2 className="mb-4 Medium text-primary">
            {currentLang === "en" ? config.contact_dha : config.contact_dha_ar ? config.contact_dha_ar : config.contact_dha}
          </h2>
          <div className="lg:flex gap-9">
          <div className="lg:w-1/2 ">
            <iframe
              title="Google Map"
              src={config.iframe_url}
              width="100%"
              height="100%"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              className="rounded-lg"
            ></iframe>
          </div>

          <div className="lg:w-1/2 lg:!mt-0 mt-4">
              <div className="mb-5">
             <h6 className="mb-2">
                {currentLang === "en" ? config.address : config.address_ar ? config.address_ar : config.address}
              </h6>
              <div>
                <p className="text-onSurfaceVariant body">
                  {currentLang === "en" ? config.dha_address_line1 : config.dha_address_line1_ar ? config.dha_address_line1_ar : config.dha_address_line1} <br />
                  {currentLang === "en" ? config.dha_address_line2 : config.dha_address_line2_ar ? config.dha_address_line2_ar : config.dha_address_line2}
                </p>
              </div>
            </div>
            <div className="mb-5">
              <h6 className="mb-2">
                {currentLang === "en" ? config.operating_hours : config.operating_hours_ar ? config.operating_hours_ar : config.operating_hours}
              </h6>
              <p className="text-onSurfaceVariant body" dangerouslySetInnerHTML={{ __html: currentLang === "en" ? config.operating_hours_detail : config.operating_hours_detail_ar ? config.operating_hours_detail_ar : config.operating_hours_detail }}></p>
            </div>

            <div className="mb-5">
              <h6 className="mb-2">
                {currentLang === "en" ? config.call_center_hours : config.call_center_hours_ar ? config.call_center_hours_ar : config.call_center_hours}
              </h6>
              <p className="text-onSurfaceVariant body" dangerouslySetInnerHTML={{ __html: currentLang === "en" ? config.call_center_hours_detail : config.call_center_hours_detail_ar ? config.call_center_hours_detail_ar : config.call_center_hours_detail }}></p>
            </div>

            <div className="mb-5">
              <h6 className="mb-2">
                {currentLang === "en" ? config.social_media : config.social_media_ar ? config.social_media_ar : config.social_media}
              </h6>
              <p className="text-onSurfaceVariant body">
                <ul className="flex align-center gap-5">
                  <li>
                    <a href="https://x.com/dha_dubai?lang=en">
                      <img className="h-[25px]"  src="/attachments/medialib/62ff71da-9b3f-4d69-bd93-059f549ddc04-1760725466061-973353473-x.svg" alt="XLogo" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/dha_dubai/?hl=en">
                      <img className="h-[25px]" src="/attachments/medialib/ef82985b-64d1-40be-9d06-660a96450357-1760725499133-555906849-insta.svg" alt="instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.tiktok.com/@dha_dubai?lang=en\">
                      <img className="h-[25px]" src="/attachments/medialib/f63fba92-c09c-4330-bf78-2ad5909a607d-1760725483286-543409722-tktok.svg" alt="tiktok" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/DubaiHealthAuthority">
                      <img className="h-[25px]" src="/attachments/medialib/054e040a-e61c-4553-9f41-710ca53d6c4f-1760725462197-373173466-fb.svg" alt="facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/dubaihealthauthority">
                      <img className="h-[25px]" src="/attachments/medialib/041986d7-53a2-46eb-8d9f-a3da58a11d43-1760725475321-877222131-in.svg" alt="linkedin" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/DubaiHealthAuthority">
                      <img className="h-[25px]" src="/attachments/medialib/f4c8af38-9b9d-4a9e-8f91-ddd442d7b7a1-1760725492348-637935532-youtube.svg" alt="youtube" />
                    </a>
                  </li>
                  <li>
                    <a href="https://api.whatsapp.com/send/?phone=971800342&text=hi&type=phone_number&app_absent=0">
                      <img className="h-[25px]" src="/attachments/medialib/ec3f31c3-b891-445b-b0d8-913b1d9dcbb2-1760725503076-706730279-whatsapp.svg" alt="whatsapp" />
                    </a>
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        </div>

        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-4">
          <div className="border rounded-2xl flex">
            <div className="p-3 flex items-center gap-4">
              <img src="/attachments/medialib/b8ead37c-2cd7-4039-bc1b-9abcf2a40090-1759751432551-446252217-Toll Free.svg" className="text-primary bg-customSurface rounded-xl p-3 w-12 h-12 " />
              <div>
                <p className="text-onSurfaceVariant body">
                  {currentLang === "en" ? config.helpline : config.helpline_ar ? config.helpline_ar : config.helpline}
                </p>
                <h5 className="h5 Regular [direction:ltr]">{config.helpline_number}</h5>
              </div>
            </div>
          </div>

          <div className="border rounded-2xl flex">
            <div className="p-3 flex items-center gap-4">
              <img src="/attachments/medialib/633ea890-bcce-4983-9782-0f8e3d74d898-1759750981972-634520495-Contact Us_International.svg" className="text-primary bg-customSurface rounded-xl p-3 w-12 h-12 " />
              <div>
                <p className="text-onSurfaceVariant body">
                  {currentLang === "en" ? config.international : config.international_ar ? config.international_ar : config.international}
                </p>
                <h5 className="h5 Regular [direction:ltr]">{config.international_number}</h5>
              </div>
            </div>
          </div>


          <div className="border rounded-2xl flex">
            <div className="p-3 flex items-center gap-4">
              <img src="/attachments/medialib/c6c8b92e-f741-4415-99b8-977233065f85-1759751011784-737920332-Email.svg" className="text-primary bg-customSurface rounded-xl p-3 w-12 h-12 " />
              <div>
                <p className="text-onSurfaceVariant body">
                  {currentLang === "en" ? config.email : config.email_ar ? config.email_ar : config.email}
                </p>
                <h5 className="h5 Regular">{config.email_address}</h5>
              </div>
            </div>
          </div>
          
                    <div className="border rounded-2xl flex">
            <div className="p-3 flex items-center gap-4">
              <img src="/attachments/medialib/41353e07-d0a8-48a0-9a93-09d9ec547ef2-1759750989841-469324547-Contact Us_P.O. Box.svg" className="text-primary bg-customSurface rounded-xl p-3 w-12 h-12 " />
              <div>
                <p className="text-onSurfaceVariant body">
                  {currentLang === "en" ? config.fax : config.fax_ar ? config.fax_ar : config.fax}
                </p>
                <h5 className="h5 Regular">{config.fax_number}</h5>
              </div>
            </div>
          </div>

        </div>

        <div key={formKey} id="contact-form">
          <h2 className="h2 Regular text-center dda-mb-2">
            {currentLang === "en" ? config.submit_inquiry : config.submit_inquiry_ar ? config.submit_inquiry_ar : config.submit_inquiry}
          </h2>
          <h5 className="h5 Regular text-center mb-[30px]">
            {currentLang === "en" ? config.inquiry_intro : config.inquiry_intro_ar ? config.inquiry_intro_ar : config.inquiry_intro}
          </h5>
        
          <div className="border border-outline rounded-xl md:!p-8 p-4">
            <form onSubmit={handleSubmit}>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <dda-input
                    placeholder={currentLang === "en" ? config.full_name_placeholder : config.full_name_placeholder_ar ? config.full_name_placeholder_ar : config.full_name_placeholder}
                    value={formData.name}
                    type="text"
                    size="default"
                    error_message={errors.name || ""}
                    validation_type="normal"
                    custom_class={errors.name ? "error" : ""}
                    component_mode=""
                    input_id="name"
                    aria_label="name"
                    onchange={(e) => handleChange({ target: { name: 'name', value: e.target.value } })}
                    input_name="name"
                    class="hydrated"
                  ></dda-input>
                  {errors.name && <div className="text-red-500 text-sm mt-1">{errors.name}</div>}
                </div>

                <div>
                  <dda-input
                    placeholder={currentLang === "en" ? config.email_placeholder : config.email_placeholder_ar ? config.email_placeholder_ar : config.email_placeholder}
                    value={formData.email}
                    type="email"
                    size="default"
                    error_message={errors.email || ""}
                    custom_class={errors.email ? "error" : ""}
                    component_mode=""
                    input_id="email"
                    aria_label="email"
                    onchange={(e) => handleChange({ target: { name: 'email', value: e.target.value } })}
                    input_name="email"
                    class="hydrated"
                  ></dda-input>
                  {errors.email && <div className="text-red-500 text-sm mt-1">{errors.email}</div>}
                </div>

                <div>
                  <dda-select
                    ref={selectRef}
                    options={currentLang === "en" ? config.query_options : config.query_options_ar ? config.query_options_ar : config.query_options}
                    label=""
                    placeholder={currentLang === "en" ? config.select_placeholder : config.select_placeholder_ar ? config.select_placeholder_ar : config.select_placeholder}
                    selected="0"
                    disabled="false"
                    helper_text=""
                    error_message={errors.queryAbout || ""}
                    validation_id="validationId"
                    size="default"
                    custom_class={`w-full ${errors.queryAbout ? "error" : ""}`}
                    component_mode=""
                    button_id="query-select"
                    aria_label="query select"
                    toggle_button_name="toggle_button"
                    option_select_button_name="option_button"
                    id="querySelect"
                  ></dda-select>
                  {errors.queryAbout && <div className="text-red-500 text-sm mt-1">{errors.queryAbout}</div>}
                </div>
                
                <div>
                  <div className="dda-input-field-group dda-phone-field [direction:ltr]">
                    <div
                      className="dda-input-dropdown-btn"
                      style={{ minWidth: "unset" }}
                    >
                      <button
                        type="button"
                        className="dda-dropdown-select"
                        onClick={() => setDropdownOpen((prev) => !prev)}
                      >
                        <img src={selectedCountry.flag} alt="" width="20" />
                        <span>{selectedCountry.code}</span>
                        <i className="material-icons">keyboard_arrow_down</i>
                      </button>

                      {dropdownOpen && (
                        <div className="dda-input-dropdown-list">
                          {CountriesList.map((country) => (
                            <button
                              key={country.code}
                              type="button"
                              className="country-select dda-input-dropdown-item"
                              onClick={() => handleSelectCountry(country)}
                            >
                              <img src={country.flag} alt="" width="20" />
                              {country.code}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    <input
                      type="tel"
                      name="phoneNumber"
                      placeholder={currentLang === "en" ? config.phone_placeholder : config.phone_placeholder_ar ? config.phone_placeholder_ar : config.phone_placeholder}
                      maxLength={15}
                      disabled={false}
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className={`dda-field-group-input ${errors.phoneNumber ? "border-red-500" : ""}`}
                      value={formData.phoneNumber}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phoneNumber && <div className="text-red-500 text-sm mt-1">{errors.phoneNumber}</div>}
                </div>
              </div>

              <dda-textarea
                placeholder={currentLang === "en" ? config.placeholder : config.placeholder_ar ? config.placeholder_ar : config.placeholder}
                max_characters="200"
                value={formData.comment}
                error_message=""
                custom_class="my-3"
                component_mode=""
                input_id="comment"
                aria_label="comment"
                onchange={(e) => handleChange({ target: { name: 'comment', value: e.target.value } })}
                textarea_name="comment"
              ></dda-textarea>

              <div className="flex w-full justify-end">
                <button
                  type="submit"
                  className="bg-primary text-white px-8 py-2 rounded-lg"
                >
                  {currentLang === "en" ? config.send_button : config.send_button_ar ? config.send_button_ar : config.send_button}
                </button>
              </div>
            </form>
          </div>
        </div>

        

      </div>
    </>
  );
};

export default ContactDHA;